import { useState } from 'react';
import { History } from 'lucide-react';
import { Button, EmptyState, ErrorState, LoadingState, Modal, Pagination } from '@/components/ui';
import { listActivity, useQuery } from '@/data';
import { ActivityItem } from '@/features/activity/ActivityItem';
import type { ActionModalProps } from '../types';

const PAGE_SIZE = 8;

export function ActivityLogModal({ pharmacy, onClose }: ActionModalProps) {
  const [page, setPage] = useState(1);
  const { data, error, loading, reload } = useQuery(
    () => listActivity({ businessId: pharmacy.id, page, pageSize: PAGE_SIZE }),
    [pharmacy.id, page],
  );

  return (
    <Modal
      open
      onClose={onClose}
      size="lg"
      title="Activity Log"
      description={`${pharmacy.name} · audit trail`}
      icon={<History size={18} aria-hidden="true" />}
      footer={
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      }
    >
      {loading ? (
        <LoadingState label="Loading activity…" />
      ) : error ? (
        <ErrorState message={error.message} action={<Button variant="secondary" onClick={reload}>Try again</Button>} />
      ) : !data || data.total === 0 ? (
        <EmptyState compact icon={<History size={20} aria-hidden="true" />} title="No activity yet" description="Administrative actions for this pharmacy will appear here." />
      ) : (
        <>
          <ul className="-my-1 divide-y divide-line">
            {data.items.map((event) => (
              <ActivityItem key={event.id} event={event} showTarget={false} />
            ))}
          </ul>
          {data.total > PAGE_SIZE && (
            <div className="-mx-4 -mb-3 mt-2 border-t border-line">
              <Pagination page={data.page} pageSize={PAGE_SIZE} total={data.total} onPageChange={setPage} itemLabel="events" />
            </div>
          )}
        </>
      )}
    </Modal>
  );
}
